import Service from "./Service"
import { getCompanyCookie, checkIfLocaleIsCSE } from "@/utils/utils"

export default class BookingService extends Service {
	constructor() {
		super()
		this.serviceUrl = `https://api.travelski.com/booking`
		// this.serviceUrl = `https://api-migdal.travelfactory.fr/dev/booking`
		this.mandatoryFields = {
			getQuotePrices: [
				"packCode",
				"liheId",
				"startDate",
				"endDate",
				"travellers",
				"season",
			],
		}
	}

	async getQuotePrices(requestData) {
		this.checkMandatoryFields(requestData, "getQuotePrices")
		const { locale, travellers, packCode, liheId, startDate, endDate, season } =
			requestData
		if (packCode === "HS")
			throw new Error("cannot request prices for HS package")
		const headers = {
			"content-type": "application/json",
			"accept-language": locale.replace("_", "-"),
			site: "TS",
		}
		const params = {
			packCode,
			liheId,
			startDate,
			endDate,
			season,
			...(checkIfLocaleIsCSE(locale) && { company: getCompanyCookie() }),
		}
		const body = JSON.stringify({ travellers })
		const url = `${this.serviceUrl}/quote/prices`
		const { data } = await this.axios.post(url, body, { params, headers })
		return data
	}
}
